import SectionHeading from "./SectionHeading";
import { discussions } from "@/mocks/community";

export default function Discussions() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="TALK · 吃瓜热议"
        title="大家都在聊什么"
        desc="精选页面内的热门讨论，观点来自网友，理性发言、就事论事，别把猜测当成结论。"
      />

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {discussions.map((item) => (
          <article
            key={item.id}
            className="flex flex-col bg-background-100 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors"
          >
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 font-heading font-bold">
                {item.initial}
              </span>
              <div className="min-w-0">
                <div className="text-sm font-medium text-foreground-900 truncate">
                  {item.user}
                </div>
                <div className="text-xs text-foreground-500">{item.time}</div>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 flex-1">
              {item.content}
            </p>
            <div className="mt-4 pt-3 border-t border-background-200 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-thumb-up-line" />
                {item.likes}
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-chat-3-line" />
                {item.replies}
              </span>
              <span className="ml-auto inline-flex items-center gap-1 text-primary-600">
                <i className="ri-price-tag-3-line" />
                {item.topic}
              </span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}